import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=42d2cfcb"
import script from "./carousel.vue?vue&type=script&lang=ts"
export * from "./carousel.vue?vue&type=script&lang=ts"
import style0 from "./carousel.vue?vue&type=style&index=0&id=42d2cfcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports